import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Case, StatusEnum } from '../models/cases/case';
import { User, UserRole } from '../models/users/user';
import { RejectRequestModalComponent } from '../reject-request-modal/reject-request-modal.component';


@Component({
  selector: 'app-file-summary-modal',
  templateUrl: './file-summary-modal.component.html',
  styleUrls: ['./file-summary-modal.component.scss']
})
export class FileSummaryModalComponent implements OnInit {
  fileInfo: Case;
  viewMode = false;

  @ViewChild('fileSummaryModal') fileSummaryModal;
  modalRef: NgbModalRef;
  @ViewChild('rejectModal') rejectModal: RejectRequestModalComponent;
  @Output() submit: EventEmitter<Case> = new EventEmitter<Case>();
  @Output() print: EventEmitter<any> = new EventEmitter<any>();

  constructor(private modalService: NgbModal,
    private fileApi: FilesApiService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(file: Case, viewMode = false) {
    this.fileInfo = file;
    this.viewMode = viewMode;
    this.modalRef = this.modalService.open(this.fileSummaryModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  // accept() {
  //   if (this.fileInfo.closingRemarks && this.fileInfo.isPending) {
  //     this.confirmClose();
  //   } else {
  //     this.acceptRequest();
  //   }
  // }

  confirmClose() {
    this.pendingFileRespond(StatusEnum.CLOSED, `File #${this.fileInfo.fileNum} is now oppened.`, this.fileApi.confirmCaseClose)
  }

  rejectClose() {
    this.pendingFileRespond(StatusEnum.OPENED, `request is rejcted!`, this.fileApi.rejectCaseClose)
  }

  confirmReopen() {
    this.pendingFileRespond(StatusEnum.OPENED, `File #${this.fileInfo.fileNum} is now oppened.`, this.fileApi.confirmCaseReopen)
  }

  rejectReopen() {
    this.pendingFileRespond(StatusEnum.CLOSED, `request is rejcted!`, this.fileApi.rejectCaseReopen)
  }

  pendingFileRespond(status: StatusEnum, msg: string, api) {
    this.spinner.show();
    api(this.fileInfo.id).subscribe(
      r => {
        this.submit.emit(this.fileInfo);
        this.close();
        this.spinner.hide();
        this.toastr.success(msg, 'Success!');
        this.fileInfo.status = status;
      }
    )
  }

  acceptRequest() {
    this.spinner.show();
    this.fileApi.acceptNewCase(this.fileInfo.id).subscribe(
      r => {
        this.submit.emit(this.fileInfo);
        this.close();
        this.fileInfo.status = StatusEnum.OPENED;
        this.spinner.hide();
        this.toastr.success(`File #${this.fileInfo.fileNum} is now opened`, 'Approved!');
      }
    )
  }

  rejectRequest() {
    this.rejectModal.open();
  }

  sendRejectionReason(reason: string) {
    this.spinner.show();
    this.fileApi.rejectNewCase(this.fileInfo.id, reason).subscribe(
      r => {
        this.submit.emit(this.fileInfo);
        this.close();
        this.spinner.hide();
        this.toastr.success('', 'Complete!');
      }
    )
  }

  isAdmin() {
    return this.authService.user && (this.authService.user.role === UserRole.ADMIN)
  }

}
